// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 30px 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.header-content {
  text-align: center;
  margin-bottom: 20px;
}

.logo-link {
  text-decoration: none;
  color: inherit;
}

.logo-link:hover {
  opacity: 0.95;
}

.company-name {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.company-subtitle {
  font-size: 18px;
  opacity: 0.9;
  font-weight: 300;
}

.header-nav {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
  gap: 10px;
}

.nav-item {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 25px;
  color: white;
  text-decoration: none;
}

.nav-item.active {
  background-color: rgba(255, 255, 255, 0.2);
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

@media (max-width: 768px) {
  .company-name {
    font-size: 24px;
  }
  
  .company-subtitle {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;EAC9C,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 30px 0;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.header-content {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.logo-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.logo-link:hover {\n  opacity: 0.95;\n}\n\n.company-name {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  letter-spacing: -0.5px;\n}\n\n.company-subtitle {\n  font-size: 18px;\n  opacity: 0.9;\n  font-weight: 300;\n}\n\n.header-nav {\n  text-align: center;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.nav-item {\n  display: inline-block;\n  padding: 10px 20px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-radius: 25px;\n  color: white;\n  text-decoration: none;\n}\n\n.nav-item.active {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.nav-item:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n@media (max-width: 768px) {\n  .company-name {\n    font-size: 24px;\n  }\n  \n  .company-subtitle {\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
